import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=02c8bd12&scoped=true"
import script from "./NumberField.vue?vue&type=script&lang=js"
export * from "./NumberField.vue?vue&type=script&lang=js"
import style0 from "./NumberField.vue?vue&type=style&index=0&id=02c8bd12&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c8bd12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c8bd12')) {
      api.createRecord('02c8bd12', component.options)
    } else {
      api.reload('02c8bd12', component.options)
    }
    module.hot.accept("./NumberField.vue?vue&type=template&id=02c8bd12&scoped=true", function () {
      api.rerender('02c8bd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/fields/NumberField.vue"
export default component.exports